import React from 'react';
import FoundationSection from '../components/FoundationSection';
import { FaFilePdf, FaDownload, FaEye } from 'react-icons/fa';

// Lista de documentos institucionales
const pdfFiles = [
  { name: 'Solicitud Regimen Tributario', url: '/docs/52451002820857.pdf' },
  { name: 'Acta 001', url: '/docs/ACTA 001.pdf' },
  { name: 'Declaracion 2024', url: '/docs/DECLARACION 2024.pdf' },
  { name: 'Camara de Comercio Sol Caribe', url: '/docs/CAMARA DE COMERCIO SOL CARIBE.pdf' },
  { name: 'Certificaciones de Asignaciones Permanentes 2024', url: '/docs/CERTIFICACIONES DE ASIGNACIONES PERMANENTES 2024.pdf' },
  { name: 'Informe de Gestion 2024', url: '/docs/01-INFORME DE GESTION 2024.pdf' },
  { name: 'Estados Financieros 2024', url: '/docs/02-ESTADOS FINANCIEROS 2024.pdf' },
  { name: 'Certificado de Requisitos de Representante Legal', url: '/docs/03-CERTIFICADO DE REQUISITOS DE REPRESENTANTE LEGAL.pdf' },
  { name: 'Certificacion Remuneracion Directivos', url: '/docs/04-CERTIFICACION REMUNERACION DIRECTIVOS.pdf' },
  { name: 'Certificaciones Antecendentes Judiciales 2024', url: '/docs/05-CERTIFICACIONES ANTECEDENTES JUDICIALES 2024.pdf' },
];

const About = () => (
  <>
    <FoundationSection
      title="Quiénes Somos: Nuestra Historia"
      id="about"
      imageSrc="/img5.jpg"
      imageAlt="Líderes comunitarios afrocolombianos"
      imagePosition="right"
    >
      <p className="text-lg md:text-xl leading-relaxed mb-6">
        En Sol Caribe, trabajamos por el desarrollo integral y la equidad de las comunidades afrocolombianas, raizales y palenqueras. Somos una fundación sin ánimo de lucro que impulsa proyectos sociales, culturales, educativos y productivos que transforman vidas.
      </p>
      <p className="text-lg md:text-xl leading-relaxed mb-6">
        Apoyamos a poblaciones en situación de vulnerabilidad, promovemos sus derechos, fortalecemos sus capacidades y generamos oportunidades reales para el progreso colectivo.
      </p>
      <p className="text-lg md:text-xl leading-relaxed mb-6">
        Creemos en la fuerza de nuestras raíces, en el poder del trabajo comunitario y en la construcción de un futuro más justo e inclusivo para todos.
      </p>
      <p className="text-lg md:text-xl leading-relaxed font-extrabold">
        Sol Caribe: identidad, dignidad y desarrollo.
      </p>
    </FoundationSection>

    {/* Sección adicional para los documentos PDF */}
    <section className="px-4 md:px-12 lg:px-20 py-10">
      <h3 className="text-2xl font-bold mb-6 text-green-800 text-center">📄 Documentos Institucionales</h3>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {pdfFiles.map((file, index) => (
          <div
            key={index}
            className="flex flex-col bg-white border border-gray-200 rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center gap-3 mb-2">
              <FaFilePdf className="text-red-600 text-2xl" />
              <h4 className="text-md font-semibold text-gray-800">{file.name}</h4>
            </div>
            <div className="flex justify-between mt-auto pt-2">
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm flex items-center gap-1"
              >
                <FaEye /> Ver
              </a>
              <a
                href={file.url}
                download
                className="text-green-600 hover:underline text-sm flex items-center gap-1"
              >
                <FaDownload /> Descargar
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default About;
